import { ApiMeta, ApiResponse, ApiEnvelope, RawPagination, NormalizedPagination } from './types';

function normalizePagination(paginationRaw?: RawPagination): NormalizedPagination | undefined {
  if (!paginationRaw || typeof paginationRaw !== 'object') {
    return undefined;
  }

  return {
    page: paginationRaw.page,
    perPage: paginationRaw.size,
    totalPages: paginationRaw.total_pages,
    totalElements: paginationRaw.total_elements,
    isFirst: paginationRaw.first,
    isLast: paginationRaw.last,
    elements: paginationRaw.elements,
  };
}

export function unwrapApiEnvelope<T>(env: ApiEnvelope<T>): ApiResponse<T> {
  const payload = env?.payload ?? null;

  const service = env?.service
    ? {
        syncStatus: env.service.sync_status,
        configured: env.service.configured,
      }
    : undefined;

  const pagination = normalizePagination(payload?.pagination);

  const meta: ApiMeta = {
    service,
    pagination,
  };

  return {
    data: payload ? payload.content : null,
    meta,
  };
}
